import { useTranslation } from 'next-i18next/pages';

import { Form, Input, Select } from 'antd';

import { TranslationNamespace } from '@/i18n';

import { ACTIVITY_TYPES } from '../../../constants';
import { contactRule } from '../../../constants/form';
import { CompactInputNumber } from '../CompactInputNumber';
import { StepActions } from '../StepActions';

import styles from '@/components/TariffCalculatorNew/TariffCalculator.module.scss';

interface StepCompanyProps {
	onNext: () => void;
}

export function StepCompany({ onNext }: StepCompanyProps) {
	const { t } = useTranslation(TranslationNamespace.Calculator);
	const activityLabels = {
		Переработка: t('activity.processing'),
		'Дистрибуция/опт': t('activity.distribution'),
		'Добыча/вылов': t('activity.fishing'),
		'Импорт/экспорт': t('activity.import-export'),
		'Смешанный тип': t('activity.mixed'),
	};
	return (
		<div className={styles.stepPanel}>
			<h2 className={styles.stepTitle}>{t('company.title')}</h2>
			<p className={styles.stepLead}>{t('company.description')}</p>

			<div className={styles.fieldGrid}>
				<Form.Item name="company" label={t('company.name')} rules={[contactRule]} required>
					<Input autoComplete="organization" size="large" />
				</Form.Item>
				<Form.Item name="activity" label={t('company.activity')}>
					<Select
						options={ACTIVITY_TYPES.map((value) => ({ value, label: activityLabels[value] }))}
						size="large"
					/>
				</Form.Item>
				<Form.Item name="name" label={t('company.your-name')} rules={[contactRule]} required>
					<Input placeholder={t('company.name-placeholder')} autoComplete="name" size="large" />
				</Form.Item>
				<Form.Item name="phone" label={t('company.phone')} rules={[contactRule]} required>
					<Input placeholder="+7 900 000-00-00" inputMode="tel" autoComplete="tel" size="large" />
				</Form.Item>
			</div>

			<h3 className={styles.sectionTitle}>{t('company.team')}</h3>
			<div className={styles.fieldGrid}>
				<Form.Item name="employees" label={t('company.employees')}>
					<CompactInputNumber min={0} step={1} addon={t('units.people')} size="large" />
				</Form.Item>
				<Form.Item name="employeeCost" label={t('company.employee-cost')}>
					<CompactInputNumber min={0} step={1000} addon={t('units.rub-month')} size="large" />
				</Form.Item>
				<Form.Item name="orders" label={t('company.orders')}>
					<CompactInputNumber min={0} step={1} addon={t('units.pcs')} size="large" />
				</Form.Item>
				<Form.Item name="activeMonths" label={t('company.active-months')}>
					<CompactInputNumber min={1} max={12} step={1} addon={t('units.months')} size="large" />
				</Form.Item>
			</div>

			<StepActions showPrev={false} onNext={onNext} />
		</div>
	);
}
